export default __webpack_public_path__ + "static/media/graph-up.cf5d9a92.svg";